<template>
<legal-document title="Политика конфиденциальности" type="privacy-policy" />
</template>

<script>
import LegalDocument from './../../components/legal/LegalDocument';
import InjectsSeo from "@/mixins/InjectsSeo";

export default {
  mixins: [InjectsSeo],

  metaInfo() {
    return {
      title: this.getFullPageTitle('Политика конфиденциальности'),
    }
  },

  components: {
    LegalDocument,
  },
}
</script>
